import {
  Box,
  Container,
  Typography,
  IconButton,
} from '@mui/material'
import {
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
  Email as EmailIcon,
} from '@mui/icons-material'
import { FooterProps } from '../types'
import { useRoleAssumption } from '../contexts/RoleAssumptionContext'

interface SocialLink {
  icon: React.ReactNode
  href: string
  label: string
}

const Footer: React.FC<FooterProps> = () => {
  const currentYear = new Date().getFullYear()
  const { isRoleAssumed } = useRoleAssumption()

  const socialLinks: SocialLink[] = [
    { icon: <GitHubIcon />, href: 'https://github.com/veilstream', label: 'GitHub' },
    { icon: <LinkedInIcon />, href: 'https://linkedin.com/company/veilstream', label: 'LinkedIn' },
    { icon: <TwitterIcon />, href: 'https://twitter.com/veilstream', label: 'Twitter' },
    { icon: <EmailIcon />, href: 'mailto:contact@veilstream.com', label: 'Email' },
  ]

  const linkSx = {
    color: 'var(--vs-text-muted)',
    textDecoration: 'none',
    '&:hover': {
      color: 'var(--vs-text-secondary)',
      textDecoration: 'underline',
    },
  }

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: isRoleAssumed ? '#8B0000' : 'var(--vs-surface)',
        borderTop: '1px solid',
        borderColor: isRoleAssumed ? '#6B0000' : 'var(--vs-border-subtle)',
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg" sx={{ py: 1.25 }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Typography variant="body2" sx={{ color: 'var(--vs-text-muted)' }}>
              © {currentYear} VeilStream. All rights reserved.
            </Typography>
            <Typography variant="body2" component="a" href="/tos" sx={linkSx}>
              Terms of Service
            </Typography>
            <Typography variant="body2" component="a" href="/privacy" sx={linkSx}>
              Privacy Policy
            </Typography>
            <Typography variant="body2" component="a" href="/tos#refund" sx={linkSx}>
              Refund Policy
            </Typography>
            <Typography
              variant="body2"
              component="a"
              href="https://pricing.veilstream.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={linkSx}
            >
              Pricing
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                size="small"
                sx={{
                  color: 'var(--vs-text-muted)',
                  '&:hover': { color: 'var(--vs-text-secondary)' },
                }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
